import React from "react";
import IconCaretDown from "../Icon/IconCaretDown";
import IconCaretsDown from "../Icon/IconCaretsDown";

const CustomPagination = ({
  total,
  page,
  handleChange,
  dataPerPage,
  handleDataPerPage,
  PAGE_SIZES,
}) => {
  const totalPages = Math.ceil(total / dataPerPage);

  const pageNumbers = [];

  // Always add first page
  pageNumbers.push(0);

  // Add ellipsis if current page is not 1 or 2
  if (page > 2) {
    pageNumbers.push("...");
  }

  // Add current page if it's not 1 or the last page
  if (page !== 0 && page !== totalPages - 1) {
    pageNumbers.push(page);
  }

  // Add ellipsis if current page is not the last or second to last
  if (page < totalPages - 2) {
    pageNumbers.push("...");
  }

  // Always add last page if it's not the same as the first page
  if (totalPages > 1) {
    pageNumbers.push(totalPages - 1);
  }

  return (
    <div className="flex md:flex-row flex-col justify-between items-center mt-4 gap-4">
      <div className="flex gap-5 items-center">
        <p>
          Showing {page * dataPerPage + 1} to{" "}
          {Math.min((page + 1) * dataPerPage, total)} of {total} entries
        </p>
        <select
          className="border border-gray-600 focus-within:outline-none rounded px-2 py-1"
          onChange={handleDataPerPage}
        >
          {PAGE_SIZES.map((item, index) => {
            return (
              <option key={index} value={item}>
                {item}
              </option>
            );
          })}
        </select>
      </div>
      <div className="flex justify-center flex-col">
        <ul className="inline-flex items-center space-x-1 rtl:space-x-reverse m-auto mb-4">
          <li>
            <button
              type="button"
              onClick={() => handleChange("First", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === 0
                  ? "cursor-default"
                  : "hover:text-white hover:bg-primary dark:text-white-light dark:bg-[#191e3a] dark:hover:bg-primary"
              }`}
            >
              <IconCaretsDown className="rotate-90 rtl:-rotate-90" />
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => handleChange("Previous", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === 0
                  ? "cursor-default"
                  : "hover:text-white hover:bg-primary dark:text-white-light dark:bg-[#191e3a] dark:hover:bg-primary"
              }`}
            >
              <IconCaretDown className="w-5 h-5 rotate-90 rtl:-rotate-90" />
            </button>
          </li>
          {pageNumbers.map((pageNumber, index) => (
            <li key={index}>
              {pageNumber === "..." ? (
                <span className="px-2 py-2">....</span>
              ) : (
                <button
                  type="button"
                  className={`flex justify-center font-semibold px-3.5 py-2 rounded-full transition ${
                    page === pageNumber
                      ? "bg-primary text-white dark:text-white-light dark:bg-primary"
                      : "bg-white-light text-dark hover:text-white hover:bg-primary dark:text-white-light dark:bg-[#191e3a] dark:hover:bg-primary"
                  }`}
                  onClick={() => handleChange("", pageNumber)}
                >
                  {pageNumber + 1}
                </button>
              )}
            </li>
          ))}
          {/* 
          {[...Array(totalPages)].map((pages, index) => {
            const pageNumber = index + 1;

            return (
              <li key={index}>
                <button
                  type="button"
                  className={`flex justify-center font-semibold px-3.5 py-2 rounded-full transition   ${
                    page === pageNumber
                      ? "bg-primary text-white dark:text-white-light dark:bg-primary"
                      : "bg-white-light text-dark hover:text-white hover:bg-primary dark:text-white-light dark:bg-[#191e3a] dark:hover:bg-primary"
                  } `}
                  onClick={() => handleChange("", pageNumber)}
                >
                  {pageNumber}
                </button>
              </li>
            );
          })} */}
          <li>
            <button
              type="button"
              onClick={() => handleChange("Next", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === totalPages - 1
                  ? "cursor-default"
                  : "hover:text-white hover:bg-primary dark:text-white-light dark:bg-[#191e3a] dark:hover:bg-primary"
              }`}
            >
              <IconCaretDown className="w-5 h-5 -rotate-90 rtl:rotate-90" />
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => handleChange("Last", page)}
              className={`flex justify-center font-semibold p-2 rounded-full transition bg-white-light text-dark ${
                page === totalPages - 1
                  ? "cursor-default"
                  : "hover:text-white hover:bg-primary dark:text-white-light dark:bg-[#191e3a] dark:hover:bg-primary"
              }`}
            >
              <IconCaretsDown className="-rotate-90 rtl:rotate-90" />
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CustomPagination;

// In this code when I have 10 pages and active page is 4 then i want to show pagination like below

// 1....4....10

// if active page is 7

// 1....7....10

// if i have 16 data and active page is 6

// 1....6....16

// if active page is 9

// 1....9....16
